import ProxyBase from '../../../../../../core/proxies/ProxyBase'

export class MacroeconomicsProxy extends ProxyBase {
  exportMacroeconomics(params) {
    return this.post('Macroeconomics/Export', params, {}, 'download')
  }
}

export default new MacroeconomicsProxy('IndustryOverview/')
